/* global React, ReactDOM, Icon, Button, IconButton, Field, Input, Select, Currency, Modal, FilterPanel, makeFilter, toast, DataList, CopyText, ConfirmDelete, ListShell, SearchField, BusinessRegistryLookup, SUPPLIERS, fmt, signedAmountColor */
const supplierFallback = () => window.PlummeBackend?.configured ? [] : (typeof SUPPLIERS !== 'undefined' ? SUPPLIERS : []);
const supplierIsArchived = (supplier) => supplier?.arkivert === true || ['passiv', 'archived'].includes(String(supplier?.status || '').toLowerCase());
const supplierText = (value) => String(value || '').trim();
const supplierKey = (value) => supplierText(value).toLowerCase();
const supplierPlaceholder = (value) => supplierText(value) || '-';
const supplierRegistryAddress = (match) => window.PlummeBusinessRegistry.formatAddress(match);
const supplierDraftFromRegistryMatch = (match, current = {}) => ({
  ...current,
  name: match?.businessName || match?.name || current.name || '',
  org: match?.organizationNumber || match?.orgnr || current.org || '',
  country: 'NO',
  email: match?.email || current.email || '',
  phone: match?.phone || current.phone || '',
  addr: supplierRegistryAddress(match) || current.addr || '',
});
// tomme felt kommer både som '' og som strek fra backend/demodata
const supplierHasValue = (value) => { const text = supplierText(value); return Boolean(text) && text !== '-' && text !== '—'; };
const supplierIsoDate = (value) => {
  const text = String(value || '');
  const match = text.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  return match ? `${match[3]}-${match[2]}-${match[1]}` : text;
};
const supplierVoucherYear = (voucher) => Number(supplierIsoDate(voucher?.date).slice(0, 4)) || null;
const supplierVoucherOrder = { unpaid: 0, partial: 1, paid: 2, credit: 3 };
const supplierMatchesVoucher = (voucher, supplier) => {
  const source = voucher.source || {};
  if (source.supplierId) return source.supplierId === supplier.id;
  if (source.supplierOrganizationNumber && supplier.org) return source.supplierOrganizationNumber === supplier.org;
  return supplierKey(voucher.name || source.supplierName) === supplierKey(supplier.name);
};
const supplierPaymentMeta = () => ({
  paid: { label: t('status.paid'), cls: 'pp-paid' },
  partial: { label: t('sup.status.partial'), cls: 'pp-unpaid' },
  unpaid: { label: t('sup.status.unpaid'), cls: 'pp-unpaid' },
  credit: { label: t('sup.status.credit'), cls: 'pp-credit' },
});
const supplierVoucherStatus = (voucher) => voucher.kind === 'kreditnota' ? 'credit' : (voucher.paymentStatus || 'paid');
const supplierVoucherLabel = (voucher) => voucher.kind === 'kreditnota' ? t('sup.status.credit') : t('sup.status.invoice');
const readSupplierVouchers = () => window.PlummeBackend?.getVouchersModel ? window.PlummeBackend.getVouchersModel() : [];
const supplierInvoiceNumberText = (voucher) => {
  const source = voucher?.source || {};
  return supplierText(source.supplierCreditNoteNumber || source.supplierInvoiceNumber || source.invoiceNumber || '');
};
const supplierInvoiceNumberKey = (value) => supplierKey(value).replace(/\s+/g, '');
const supplierInvoiceConflictLabel = (vouchers) => vouchers
  .map((voucher) => supplierIsoDate(voucher.date || voucher.source?.date || '') || voucher.id)
  .filter(Boolean)
  .join(', ');
const collectSupplierInvoiceNumbers = (supplier) => {
  const map = new Map();
  readSupplierVouchers()
    .filter((voucher) => voucher.kind === 'leverandorfaktura' && supplierMatchesVoucher(voucher, supplier))
    .forEach((voucher) => {
      const invoiceNumber = supplierInvoiceNumberText(voucher);
      const key = supplierInvoiceNumberKey(invoiceNumber);
      if (!key) return;
      const entry = map.get(key) || { invoiceNumber, vouchers: [] };
      entry.vouchers.push(voucher);
      map.set(key, entry);
    });
  return map;
};
const findSupplierMergeInvoiceConflicts = (first, second) => {
  if (!first || !second) return [];
  const firstInvoices = collectSupplierInvoiceNumbers(first);
  const secondInvoices = collectSupplierInvoiceNumbers(second);
  return Array.from(firstInvoices.entries())
    .filter(([key]) => secondInvoices.has(key))
    .map(([key, firstEntry]) => ({ ...firstEntry, otherVouchers: secondInvoices.get(key).vouchers }));
};
const supplierExportColumns = () => [
  { header: t('sup.number'), value: (s) => s.nr || '' },
  { header: t('sup.export.internalId'), value: (s) => s.id || '' },
  { header: t('cust.export.name'), value: (s) => s.name || '' },
  { header: t('cust.export.org'), value: (s) => s.org || '' },
  { header: t('sup.countryCode'), value: (s) => s.country || '' },
  { header: t('sup.registrationNumber'), value: (s) => s.registrationNumber || '' },
  { header: t('sup.vatNumber'), value: (s) => s.vatNumber || '' },
  { header: t('cust.export.email'), value: (s) => s.email || '' },
  { header: t('cust.export.phone'), value: (s) => s.phone || '' },
  { header: t('cust.export.address'), value: (s) => s.addr || '' },
  { header: t('cust.export.status'), value: (s) => s.status || 'aktiv' },
  { header: t('cust.col.outstanding'), value: (s) => s.out || 0 },
  { header: t('sup.totalPurchases'), value: (s) => s.buy || 0 },
];
const supplierLedgerColumns = () => [
  { header: t('cust.ledger.code'), value: (r) => r.code },
  { header: t('cust.export.name'), value: (r) => r.name },
  { header: t('cust.export.org'), value: (r) => r.org },
  { header: t('cust.ledger.date'), value: (r) => r.date },
  { header: t('cust.ledger.doc'), value: (r) => r.doc },
  { header: t('cust.ledger.type'), value: (r) => r.type },
  { header: t('cust.ledger.due'), value: (r) => r.due },
  { header: t('cust.ledger.debit'), value: (r) => r.debit },
  { header: t('cust.ledger.credit'), value: (r) => r.credit },
  { header: t('cust.ledger.balance'), value: (r) => r.balance },
  { header: t('cust.ledger.paid'), value: (r) => r.paid },
  { header: t('cust.ledger.remaining'), value: (r) => r.remaining },
  { header: t('cust.export.status'), value: (r) => r.status },
];
const supplierExportRowsXlsx = async (filename, columns, rows, sheetName) => {
  await loadXLSX().catch(() => {});
  if (!window.XLSX) throw new Error(t('sup.excelUnavailable'));
  const matrix = [
    columns.map((column) => column.header),
    ...rows.map((row) => columns.map((column) => column.value(row))),
  ];
  const workbook = window.XLSX.utils.book_new();
  const worksheet = window.XLSX.utils.aoa_to_sheet(matrix);
  window.XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  window.XLSX.writeFile(workbook, `${filename}.xlsx`);
};
const openSupplierVoucher = (voucher, setRoute, setYear) => {
  const targetYear = supplierVoucherYear(voucher);
  window.__plummeVoucherFilter = {
    checks: { leverandorfaktura: true },
    focusVoucherId: voucher.id,
    search: voucher.num || voucher.name || '',
    from: 'leverandorer',
  };
  if (targetYear && typeof setYear === 'function') setYear(targetYear);
  if (typeof setRoute === 'function') setRoute('allebilag');
  else toast(t('sup.voucherUnderTransactions'), 'info');
};

// Kebab som erstatter «Se bilag»/«Gå til» på smale rader (designets sup-fak-kebab)
function SupplierRowMenu({ actions }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => { if (ref.current && !ref.current.contains(event.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  if (!actions.length) return null; return <div ref={ref} style={{ position: 'relative', flex: 'none' }}>
    <IconButton name="dots" size="sm" variant={open ? 'primary' : 'ghost'} title={t('buy.moreOptions')} onClick={(event) => { event.stopPropagation(); setOpen((value) => !value); }} />
    {open && <div className="pop pop-menu right" style={{ minWidth: 190 }}>{actions.map((action, index) => <button key={index} disabled={action.disabled} onClick={(event) => { event.stopPropagation(); setOpen(false); action.onClick(); }}><Icon name={action.icon} size={16} />{action.label}</button>)}</div>}
  </div>;
}
function ImportedSupplierOpenItems({ items }) {
  return <ImportedAccountingOpenItems items={items} kind="supplier" />;
}
const supplierNetBalanceMeta = (amount) => {
  const value = Math.round(Number(amount) || 0);
  if (value > 0) return { text: t('sup.balance.youOwe', { amount: fmt(value) }), tone: 'var(--warning)' };
  if (value < 0) return { text: t('sup.balance.supplierOwes', { amount: fmt(Math.abs(value)) }), tone: 'var(--success)' };
  return { text: t('cust.balance.settled'), tone: 'var(--ink)' };
};
// Selve panelet er delt (src/services/businessRegistryLookup.jsx). Navnet blir
// staaende fordi purchases.jsx og vat.jsx henter det som window.SupplierRegistryLookup.
function SupplierRegistryLookup(props) {
  return <BusinessRegistryLookup {...props} />;
}

function SupplierDetail({ supplier, onEdit, onDelete, onReopen, onMerge, setRoute, setYear }) {
  const [filter, setFilter] = useState('all');
  const [tab, setTab] = useState('invoices');
  const [page, setPage] = useState(1);
  const [preview, setPreview] = useState(null);
  const [openedInvoice, setOpenedInvoice] = useState(null);
  const [overpaymentDialog, setOverpaymentDialog] = useState(null);
  const [overpaymentForm, setOverpaymentForm] = useState({ sourceExpenseId: '', amount: '', date: new Date().toISOString().slice(0, 10), settlementAccountCode: '1920' });
  const vouchers = readSupplierVouchers()
    .filter((voucher) => (voucher.kind === 'leverandorfaktura' || voucher.kind === 'kreditnota') && supplierMatchesVoucher(voucher, supplier))
    .sort((a, b) => {
      const statusDiff = (supplierVoucherOrder[supplierVoucherStatus(a)] ?? 9) - (supplierVoucherOrder[supplierVoucherStatus(b)] ?? 9);
      if (statusDiff) return statusDiff;
      return supplierIsoDate(b.date).localeCompare(supplierIsoDate(a.date));
    });
  const shown = vouchers.filter((voucher) => {
    const status = supplierVoucherStatus(voucher);
    if (filter === 'unpaid') return status === 'unpaid' || status === 'partial';
    if (filter === 'paid') return status === 'paid';
    return true;
  });
  const perPage = 10;
  const pages = Math.max(1, Math.ceil(shown.length / perPage));
  const currentPage = Math.min(page, pages);
  const pageRows = shown.slice((currentPage - 1) * perPage, currentPage * perPage);
  const total = shown.reduce((sum, voucher) => sum + (voucher.kind==='kreditnota'?-1:1)*Math.abs(voucher.gross || 0), 0);
  const balanceMeta = supplierNetBalanceMeta(supplier.out);
  const openSupplierVoucherDocument = async (voucher) => {
    try {
      if (!window.PlummeBackend?.openVoucherDocument) throw new Error(t('sup.voucherViewNotConnected'));
      setPreview({ loading: true, name: voucher.num || t('sup.voucherFallbackName') });
      const next = await window.PlummeBackend.openVoucherDocument(voucher);
      setPreview(next);
    } catch (error) {
      setPreview({ error: error?.message || t('sup.cannotShowVoucher'), name: voucher?.num || t('sup.voucherFallbackName') });
      toast(error?.message || t('sup.cannotFetchVoucher'), 'error');
    }
  };
  const closePreview = () => {
    if (preview?.objectUrl && preview?.src) URL.revokeObjectURL(preview.src);
    setPreview(null);
  };
  const previewMime = String(preview?.mimeType || '').toLowerCase();
  const previewName = String(preview?.name || t('sup.voucherFallbackName'));
  const previewSrc = preview?.src || preview?.url || '';
  const previewDownloadOnly = Boolean(preview?.downloadOnly);
  const previewIsPdf = previewMime.includes('pdf') || /\.pdf($|\?)/i.test(previewSrc) || /\.pdf$/i.test(previewName);
  const previewIsImage = previewMime.startsWith('image/') || /\.(png|jpe?g|webp|gif|bmp)($|\?)/i.test(previewSrc) || /\.(png|jpe?g|webp|gif|bmp)$/i.test(previewName);
  const saveSupplierOverpayment = async () => {
    try {
      const amount = Number(String(overpaymentForm.amount || '').replace(',', '.'));
      if (!Number.isFinite(amount) || amount <= 0) throw new Error(t('sup.overpayment.invalidAmount'));
      if (overpaymentDialog?.kind === 'credit') {
        await window.PlummeBackend.createSupplierCreditNote({ expenseId: overpaymentDialog.voucher.sourceId || overpaymentDialog.voucher.id, amount, date: overpaymentForm.date }); toast(t('sup.credit.created','Leverandørkreditnotaen er bokført'), 'success');
      } else if (overpaymentDialog?.kind === 'credit-refund') {
        await window.PlummeBackend.refundSupplierCreditNote({ creditId: overpaymentDialog.credit.id, date: overpaymentForm.date, settlementAccountCode: overpaymentForm.settlementAccountCode }); toast(t('sup.credit.refunded','Refusjonen er bokført'), 'success');
      } else if (overpaymentDialog?.kind === 'refund') {
        await window.PlummeBackend.refundSupplierOverpayment({ expenseId: overpaymentDialog.voucher.sourceId || overpaymentDialog.voucher.id, amount, date: overpaymentForm.date, settlementAccountCode: overpaymentForm.settlementAccountCode, note: t('sup.overpayment.refundTitle') });
        toast(t('sup.overpayment.refunded'), 'success');
      } else {
        await window.PlummeBackend.allocateSupplierOverpayment({ expenseId: overpaymentDialog.voucher.sourceId || overpaymentDialog.voucher.id, sourceExpenseId: overpaymentForm.sourceExpenseId, amount, date: overpaymentForm.date, note: t('sup.overpayment.allocateTitle') });
        toast(t('sup.overpayment.allocated'), 'success');
      }
      setOverpaymentDialog(null);
    } catch (error) {
      toast(error?.message || t('sup.overpayment.failed'), 'error');
    }
  };
  const openSupplierRefund = (voucher) => { setOverpaymentForm({ sourceExpenseId: voucher.sourceId || voucher.id, amount: String(voucher.overpaidAmount || ''), date: new Date().toISOString().slice(0, 10), settlementAccountCode: supplier.defaultSettlementAccountCode || '1920' }); setOverpaymentDialog({ kind: 'refund', voucher }); };
  const openSupplierAllocation = (voucher) => { const source = (voucher.availableSupplierOverpayments || [])[0]; setOverpaymentForm({ sourceExpenseId: source?.id || '', amount: String(Math.min(Number(voucher.remainingAmount) || 0, Number(source?.amount) || 0)), date: new Date().toISOString().slice(0, 10), settlementAccountCode: supplier.defaultSettlementAccountCode || '1920' }); setOverpaymentDialog({ kind: 'allocation', voucher }); };
  const openSupplierCredit = (voucher) => { setOverpaymentForm({ sourceExpenseId: voucher.sourceId || voucher.id, amount: '', date: new Date().toISOString().slice(0, 10), settlementAccountCode: supplier.defaultSettlementAccountCode || '1920' }); setOverpaymentDialog({ kind: 'credit', voucher }); };
  const openSupplierCreditRefund = (voucher, credit) => { setOverpaymentForm({ sourceExpenseId: voucher.sourceId || voucher.id, amount: String(window.PlummeFinancialWorkflows.supplierCreditAvailable(window.PlummeBackend.appState, credit) || ''), date: new Date().toISOString().slice(0, 10), settlementAccountCode: supplier.defaultSettlementAccountCode || '1920' }); setOverpaymentDialog({ kind: 'credit-refund', voucher, credit }); };
  const invoiceActions = (voucher) => {
           const canPreview = voucher.hasAttachment || voucher.sourceType === 'invoice'; const credits=(window.PlummeBackend?.appState?.expenses||[]).filter((entry)=>entry?.manualPosting&&entry?.status!=='annulled'&&String(entry.supplierCreditForExpenseId||'')===String(voucher.sourceId||voucher.id));
           const refundableCredits=credits.filter((credit)=>window.PlummeFinancialWorkflows.supplierCreditAvailable(window.PlummeBackend.appState, credit)>0.005);
    return <React.Fragment>              <div className="row wrap gap-10">
                {Number(voucher.overpaidAmount) > 0.005 && <Button size="sm" variant="secondary" icon="refresh" onClick={(event) => { event.stopPropagation(); openSupplierRefund(voucher); }} data-help={t('helpTopics.overpayment.body')} data-help-title={t('helpTopics.overpayment.title')}>{t('sup.overpayment.refundAction')}</Button>}
                {Number(voucher.remainingAmount) > 0.005 && (voucher.availableSupplierOverpayments || []).length > 0 && <Button size="sm" variant="secondary" icon="swap" onClick={(event) => { event.stopPropagation(); openSupplierAllocation(voucher); }} data-help={t('helpTopics.overpayment.body')} data-help-title={t('helpTopics.overpayment.title')}>{t('sup.overpayment.allocateAction')}</Button>} <Button size="sm" variant="secondary" icon="files" onClick={(event)=>{event.stopPropagation();openSupplierCredit(voucher);}}>{t('sup.credit.action','Kreditnota')}</Button> {refundableCredits[0]&&<Button size="sm" variant="secondary" icon="refresh" onClick={(event)=>{event.stopPropagation();openSupplierCreditRefund(voucher,refundableCredits[0]);}}>{t('sup.credit.refundAction','Registrer refusjon')}</Button>}
                <Button size="sm" variant="secondary" icon="eye" disabled={!canPreview} title={canPreview ? t('sup.previewVoucher') : t('sup.noVoucherUploaded')} onClick={(event) => { event.stopPropagation(); void openSupplierVoucherDocument(voucher); }}>{t('sup.seeVoucher')}</Button>
                <Button size="sm" variant="secondary" onClick={(event) => { event.stopPropagation(); openSupplierVoucher(voucher, setRoute, setYear); }}>{t('sup.goTo')}</Button>
              </div>
              <div className="supplier-invoice-more"><SupplierRowMenu actions={[
                ...(voucher.payments || []).filter((payment) => payment.createdByFlow === 'supplier-overpayment-refund').map((payment) => ({ icon: 'refresh', label: t('sup.overpayment.reverseRefund'), onClick: async () => { try { await window.PlummeBackend.reverseSupplierOverpaymentRefund({ expenseId: voucher.sourceId || voucher.id, paymentId: payment.id }); toast(t('sup.overpayment.refundReversed'), 'success'); } catch (error) { toast(error?.message || t('sup.overpayment.reverseRefundFailed'), 'error'); } } })),
                ...(voucher.supplierOverpaymentAllocations || []).map((allocation) => ({ icon: 'refresh', label: t('sup.overpayment.reverseAllocation'), onClick: async () => { try { await window.PlummeBackend.reverseSupplierOverpaymentAllocation({ expenseId: allocation.expenseId, settlementId: allocation.id }); toast(t('sup.overpayment.allocationReversed'), 'success'); } catch (error) { toast(error?.message || t('sup.overpayment.reverseAllocationFailed'), 'error'); } } })), ...refundableCredits.slice(1).map((credit)=>({icon:'refresh',label:t('sup.credit.refundAction','Registrer refusjon'),onClick:()=>openSupplierCreditRefund(voucher,credit)})),
              ]} /></div>
</React.Fragment>;
  };
  return <div className="cust-detail">
    {openedInvoice&&<window.SupplierInvoiceDetail voucher={openedInvoice} onClose={()=>setOpenedInvoice(null)} actions={(voucher)=><window.PurchaseDetailActions voucher={voucher}/>}/>}
    {overpaymentDialog?.kind === 'credit' && <window.SupplierCreditNoteDialog voucher={overpaymentDialog.voucher} onClose={() => setOverpaymentDialog(null)}/>}
    {overpaymentDialog && overpaymentDialog.kind !== 'credit' && <Modal open portal onClose={() => setOverpaymentDialog(null)} title={overpaymentDialog.kind==='credit'?t('sup.credit.title','Registrer leverandørkreditnota'):overpaymentDialog.kind==='credit-refund'?t('sup.credit.refundTitle','Registrer refusjon av kreditnota'):t(overpaymentDialog.kind === 'refund' ? 'sup.overpayment.refundTitle' : 'sup.overpayment.allocateTitle')} max={560}
      footer={<React.Fragment><Button variant="ghost" onClick={() => setOverpaymentDialog(null)}>{t('common.cancel')}</Button><Button icon="check" onClick={saveSupplierOverpayment}>{overpaymentDialog.kind==='credit'?t('sup.credit.action','Bokfør kreditnota'):overpaymentDialog.kind==='credit-refund'?t('sup.credit.refundAction','Registrer refusjon'):t(overpaymentDialog.kind === 'refund' ? 'sup.overpayment.refundAction' : 'sup.overpayment.allocateAction')}</Button></React.Fragment>}>
      <div className="col gap-12">
        {overpaymentDialog.kind === 'allocation' && <Field label={t('sup.overpayment.source')} help={t('helpTopics.overpayment.body')} helpTitle={t('helpTopics.overpayment.title')}><Select value={overpaymentForm.sourceExpenseId} onChange={(event) => { const source = (overpaymentDialog.voucher.availableSupplierOverpayments || []).find((entry) => entry.id === event.target.value); setOverpaymentForm((current) => ({ ...current, sourceExpenseId: event.target.value, amount: String(Math.min(Number(overpaymentDialog.voucher.remainingAmount) || 0, Number(source?.amount) || 0)) })); }}>{(overpaymentDialog.voucher.availableSupplierOverpayments || []).map((entry) => <option key={entry.id} value={entry.id}>{entry.num} · {fmt(entry.amount)}</option>)}</Select></Field>}
        <Field label={t('sup.overpayment.amount')}><Currency value={overpaymentForm.amount} onChange={(event) => setOverpaymentForm((current) => ({ ...current, amount: event.target.value }))}/></Field>
        <Field label={t('sup.overpayment.date')}><Input type="date" value={overpaymentForm.date} onChange={(event) => setOverpaymentForm((current) => ({ ...current, date: event.target.value }))}/></Field>
        {['refund','credit-refund'].includes(overpaymentDialog.kind) && <Field label={t('sup.overpayment.bankAccount')}><Input value={overpaymentForm.settlementAccountCode} onChange={(event) => setOverpaymentForm((current) => ({ ...current, settlementAccountCode: event.target.value }))} inputMode="numeric"/></Field>}
      </div>
    </Modal>}
    {preview && <Modal open onClose={closePreview} title={previewName} max={980}
      footer={<React.Fragment>
        {previewSrc && !preview.loading && !preview.error && <Button variant="secondary" icon="download" onClick={() => { const a = document.createElement('a'); a.href = previewSrc; a.download = previewName; document.body.appendChild(a); a.click(); a.remove(); }}>{t('list.download')}</Button>}
        <Button variant="ghost" onClick={closePreview}>{t('common.close')}</Button>
      </React.Fragment>}>
      {preview.loading ? <div className="pdfv-msg"><Icon name="receipt" size={28}/><b>{t('voucher.loadingPreview')}</b></div>
        : preview.error ? <div className="pdfv-msg"><Icon name="fileText" size={28}/><b style={{ color: 'var(--error)' }}>{preview.error}</b></div>
        : previewDownloadOnly ? <div className="pdfv-msg"><Icon name="fileText" size={28}/><b>{previewName}</b><span className="muted" style={{ fontWeight: 600 }}>{t('voucher.cannotPreviewUse')}</span></div>
        : previewIsPdf ? <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', overflow: 'hidden' }}><iframe src={previewSrc} title={previewName} style={{ display: 'block', width: '100%', height: '72vh', border: 0 }}/></div>
        : previewIsImage ? <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', padding: 12, maxHeight: '72vh', overflow: 'auto' }}><img src={previewSrc} alt={previewName} style={{ display: 'block', maxWidth: '100%', height: 'auto', margin: '0 auto', borderRadius: 'var(--r-2xs)' }}/></div>
        : <div className="pdfv-msg"><Icon name="fileText" size={28}/><b>{previewName}</b><span className="muted" style={{ fontWeight: 600 }}>{t('voucher.cannotPreview')}</span></div>}
    </Modal>}
    <div className="cust-crm">
      <div className="cust-crm-grid" style={{ maxWidth: 640, gridTemplateColumns: '1fr 1fr 1fr' }}>
        <div><div className="t-sm muted" style={{ fontWeight: 700 }}>{t('sup.number')}</div><div className="t-h3" style={{ fontSize: 14 }}>{supplierPlaceholder(supplier.nr)}</div></div>
        <div><div className="t-sm muted" style={{ fontWeight: 700 }}>{t('cust.col.email')}</div><div className="t-h3" style={{ fontSize: 14 }}>{supplierPlaceholder(supplier.email)}</div></div>
        <div><div className="t-sm muted" style={{ fontWeight: 700 }}>{t('cust.col.phone')}</div><div className="t-h3" style={{ fontSize: 14 }}>{supplierPlaceholder(supplier.phone)}</div></div>
        <div><div className="t-sm muted" style={{ fontWeight: 700 }}>{t('cust.col.org')}</div><div className="t-h3" style={{ fontSize: 14 }}>{supplierPlaceholder(supplier.org)}</div></div>
        {supplierHasValue(supplier.country) && <div><div className="t-sm muted" style={{ fontWeight: 700 }}>{t('sup.countryCode')}</div><div className="t-h3" style={{ fontSize: 14 }}>{supplier.country}</div></div>}
        {supplierHasValue(supplier.registrationNumber) && <div><div className="t-sm muted" style={{ fontWeight: 700 }}>{t('sup.registrationNumber')}</div><div className="t-h3" style={{ fontSize: 14 }}>{supplier.registrationNumber}</div></div>}
        {supplierHasValue(supplier.vatNumber) && <div><div className="t-sm muted" style={{ fontWeight: 700 }}>{t('sup.vatNumber')}</div><div className="t-h3" style={{ fontSize: 14 }}>{supplier.vatNumber}</div></div>}
      </div>
    </div>
    <div className="cust-sales">
      <div className="row between wrap gap-10" style={{ marginBottom: 12 }}>
        <div className="seg-mini">{[['invoices', t('sup.invoices')], ['ledger', t('cust.ledgerShort')]].map(([key, label]) => <button key={key} className={tab === key ? 'active' : ''} onClick={(event) => { event.stopPropagation(); setTab(key); }}>{label}</button>)}</div>
        <span className="pp" style={{ background: 'var(--panel)', color: balanceMeta.tone, borderColor: 'var(--border-strong)' }}>{balanceMeta.text}</span>
      </div>
      <div className="row wrap gap-14 mb-12 t-sm"><span>{t('supplierPay.openTotal')}: <b>{fmt(vouchers.reduce((sum,v)=>sum+Number(v.remainingAmount||0),0))}</b></span><span>{t('supplierPay.available')}: <b>{fmt(window.PlummeSupplierPaymentFlow.availableForSupplier(supplier,vouchers))}</b></span></div>
      {tab === 'ledger' ? <SupplierLedgerTable supplier={supplier} /> : <React.Fragment>
      <div className="row between wrap gap-10" style={{ marginBottom: 12 }}>
        <strong className="t-h3" style={{ fontSize: 15 }} data-help-title={t('sup.invoices')} data-help={t('sup.invoicesHelp')}>{t('sup.invoices')}</strong>
        <div className="seg-mini">{[['all', t('sup.filter.all')], ['unpaid', t('sup.status.unpaid')], ['paid', t('status.paid')]].map(([key, label]) => <button key={key} className={filter === key ? 'active' : ''} onClick={(event) => { event.stopPropagation(); setFilter(key); setPage(1); }}>{label}</button>)}</div>
      </div>
      {shown.length === 0 ? <div className="t-sm muted" style={{ padding: '14px 2px', fontWeight: 600 }}>{t('sup.noInvoicesMatch')}</div> :
        <div className="col gap-8">{pageRows.map((voucher) => {
          const status = supplierVoucherStatus(voucher);
           const paymentMeta = supplierPaymentMeta();
           const meta = paymentMeta[status] || paymentMeta.paid;
          return <div key={voucher.id} className="cust-sale-row">
            <div className="row gap-10" style={{ minWidth: 0, flex: 1 }}><span className="icon-chip" style={{ background: 'var(--panel)', width: 30, height: 30 }}><Icon name={voucher.kind === 'kreditnota' ? 'files' : 'receipt'} size={16} /></span>
              <div style={{ minWidth: 0 }}><div className="t-h3" style={{ fontSize: 13.5 }}>{supplierVoucherLabel(voucher)} #{supplierInvoiceNumberText(voucher)||voucher.num} <span className="sup-fak-date muted" style={{ fontWeight: 600 }}><span className="sup-fak-sep">· </span>{voucher.date}</span></div><span className={'pp sup-pp-inline ' + meta.cls}>{meta.label}</span></div></div>
            <div className={'row gap-10' + (status === 'unpaid' || status === 'partial' ? ' sup-fak-unpaid' : '')} style={{ flex: 'none' }}><b className="t-num" style={{ fontSize: 13.5, color: signedAmountColor(voucher.kind === 'kreditnota' ? -Math.abs(voucher.gross || 0) : Math.abs(voucher.gross || 0)) }}>{fmt(voucher.kind === 'kreditnota' ? -Math.abs(voucher.gross || 0) : Math.abs(voucher.gross || 0))}</b>
              <span className={'pp sup-pp-main ' + meta.cls}>{meta.label}</span>
              <Button size="sm" variant="secondary" icon="eye" onClick={(event)=>{event.stopPropagation();setOpenedInvoice(voucher);}}>{t('supplierPay.open')}</Button>
            </div>
          </div>;
        })}</div>}
      {pages > 1 && <div className="row between" style={{ marginTop: 12, alignItems: 'center' }}>
        <span className="t-sm muted">{(currentPage - 1) * perPage + 1}-{Math.min(currentPage * perPage, shown.length)} {t('sharedText.transaction.by')} {shown.length}</span>
        <div className="row gap-6">
          <Button size="sm" variant="secondary" icon="chevLeft" disabled={currentPage <= 1} onClick={(event) => { event.stopPropagation(); setPage(Math.max(1, currentPage - 1)); }}>{t('cust.prev')}</Button>
          <span className="t-sm" style={{ fontWeight: 800, alignSelf: 'center' }}>{currentPage} / {pages}</span>
          <Button size="sm" variant="secondary" iconRight="chevRight" disabled={currentPage >= pages} onClick={(event) => { event.stopPropagation(); setPage(Math.min(pages, currentPage + 1)); }}>{t('cust.next')}</Button>
        </div>
      </div>}
      <div className="row between" style={{ marginTop: 12 }}><span className="t-sm muted" style={{ fontWeight: 700 }}>{t('cust.salesTotal')}</span><b className="t-num">{fmt(total)}</b></div>
      </React.Fragment>}
    </div>
    <ImportedSupplierOpenItems items={supplier.importedOpenItems} />
    <window.SupplierDetailActions supplier={supplier} onEdit={onEdit} onArchive={onDelete} onReopen={onReopen} onMerge={onMerge}/>
  </div>;
}

function SupplierMergePicker({ candidates, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [menuStyle, setMenuStyle] = useState(null);
  const ref = useRef(null);
  const menuRef = useRef(null);
  const positionMenu = useCallback(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setMenuStyle({
      position: 'fixed',
      top: rect.bottom + 8,
      left: rect.left,
      right: 'auto',
      width: rect.width,
      zIndex: 10000,
    });
  }, []);
  useEffect(() => {
    if (!open) return undefined;
    positionMenu();
    const close = (event) => {
      if (ref.current?.contains(event.target) || menuRef.current?.contains(event.target)) return;
      setOpen(false);
    };
    const move = () => positionMenu();
    const key = (event) => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', key);
    window.addEventListener('resize', move);
    window.addEventListener('scroll', move, true);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', key);
      window.removeEventListener('resize', move);
      window.removeEventListener('scroll', move, true);
    };
  }, [open, positionMenu]);
  const selected = candidates.find((entry) => entry.id === value) || null;
  const needle = supplierKey(query);
  const list = candidates.filter((entry) => !needle || [entry.nr, entry.name, entry.org, entry.email].some((part) => supplierKey(part).includes(needle)));
  const menu = open && <div className="merge-picker-pop" style={menuStyle || undefined} ref={menuRef}>
    <Input icon="search" autoFocus placeholder={t('sup.searchPh')} value={query} onChange={(event) => setQuery(event.target.value)} />
    <div className="merge-picker-list">
      {list.length ? list.map((entry) => <button key={entry.id} type="button" className="merge-picker-option" onClick={() => { onChange(entry.id); setQuery(''); setOpen(false); }}>
        <span>{entry.name}</span><b>{entry.nr || entry.org || '—'}</b>
      </button>) : <div className="combo-empty t-sm muted">{t('srch.noMatches', { query })}</div>}
    </div>
  </div>;
  return <div className="merge-picker" ref={ref}>
    <button type="button" className="input merge-picker-trigger" onClick={() => setOpen((current) => !current)}>
      <span className={selected ? '' : 'muted'}>{selected ? selected.name + (selected.org ? ' · ' + selected.org : '') : t('sup.mergePickerPlaceholder')}</span>
      <Icon name="chevDown" size={16} />
    </button>
    {menu && ReactDOM?.createPortal ? ReactDOM.createPortal(menu, document.body) : menu}
  </div>;
}
function SupplierMergeCard({ supplier, role }) {
  return <div className={'merge-card' + (role === 'primary' ? ' is-primary' : '')}>
    <div className="merge-card-tag">{role === 'primary' ? t('sup.mergeKeep') : t('sup.mergeRemove')}</div>
    <div className="merge-card-name">{supplier.name}</div>
    <div className="merge-card-meta">
      {supplier.nr ? <div><span>{t('sup.number')}</span><b>{supplier.nr}</b></div> : null}
      {supplier.org ? <div><span>{t('sale.cust.org')}</span><b>{supplier.org}</b></div> : null}
      {supplier.email ? <div><span>{t('cust.col.email')}</span><b>{supplier.email}</b></div> : null}
      {supplier.phone ? <div><span>{t('cust.col.phone')}</span><b>{supplier.phone}</b></div> : null}
      <div><span>{t('sup.totalPurchases')}</span><b>{fmt(supplier.buy || 0)}</b></div>
      <div><span data-help={t('helpTopics.openItem.body')} data-help-title={t('helpTopics.openItem.title')}>{t('cust.col.outstanding')}</span><b>{fmt(supplier.out || 0)}</b></div>
    </div>
  </div>;
}
function SupplierMergeModal({ supplier, suppliers, onClose, onMerged }) {
  const [duplicateId, setDuplicateId] = useState('');
  const [keepDuplicate, setKeepDuplicate] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!supplier) return null;
  const candidates = suppliers.filter((entry) => entry.id !== supplier.id && entry.status !== 'passiv');
  const duplicate = candidates.find((entry) => entry.id === duplicateId) || null;
  const master = keepDuplicate ? (duplicate || supplier) : supplier;
  const other = keepDuplicate ? supplier : duplicate;
  const combinedOut = (supplier.out || 0) + (duplicate ? (duplicate.out || 0) : 0);
  const combinedBuy = (supplier.buy || 0) + (duplicate ? (duplicate.buy || 0) : 0);
  const invoiceConflicts = duplicate ? findSupplierMergeInvoiceConflicts(master, other) : [];
  const run = async () => {
    if (!duplicate || !other || master.id === other.id) return;
    setBusy(true);
    setError('');
    try {
      if (!window.PlummeBackend?.mergeSuppliers) throw new Error(t('sup.mergeBackendNotReady'));
      const rows = await window.PlummeBackend.mergeSuppliers(master.id, other.id);
      if (Array.isArray(rows)) onMerged(rows);
      onClose();
      toast(t('sup.mergeSuccess'), 'success');
    } catch (err) {
      setError(err?.message || t('sup.mergeFailed'));
    } finally {
      setBusy(false);
    }
  };
  return <Modal open center onClose={onClose} title={t('sup.mergeTitle')} max={620}
    footer={<React.Fragment><Button variant="ghost" onClick={onClose} disabled={busy}>{t('common.cancel')}</Button><Button icon="swap" disabled={!duplicate || busy} onClick={run}>{busy ? t('sup.merging') : t('sup.mergeAction')}</Button></React.Fragment>}>
    <div className="col gap-14" style={{ paddingBottom: 4 }}>
      <div style={{ background: 'var(--plum-50)', border: '1px solid var(--plum-200)', borderRadius: 'var(--r-md)', padding: '13px 15px' }}>
        <b>{t('sup.mergeIntro')}</b>
        <div className="t-sm" style={{ fontWeight: 600, color: 'var(--ink-2)', marginTop: 3 }}>{t('sup.mergeModalIntro')}</div>
      </div>
      <Field label={t('sup.mergeFieldLabel', { name: supplier.name })}>
        <SupplierMergePicker candidates={candidates} value={duplicateId} onChange={(id) => { setDuplicateId(id); setKeepDuplicate(false); }} />
      </Field>
      {duplicate && <React.Fragment>
        <div className="merge-grid">
          <SupplierMergeCard supplier={master} role="primary" />
          <button type="button" className="merge-flip" title={t('sup.mergeSwap')} onClick={() => setKeepDuplicate((current) => !current)}><Icon name="swap" size={18} /></button>
          <SupplierMergeCard supplier={other} role="duplicate" />
        </div>
        <div className="merge-preview">
          <div className="merge-preview-h">{t('cust.merge.after')}</div>
          <div className="merge-preview-row"><span>{t('sup.name')}</span><b>{master.name}</b></div>
          <div className="merge-preview-row"><span>{t('sup.totalPurchases')}</span><b className="t-num">{fmt(combinedBuy)}</b></div>
          <div className="merge-preview-row"><span data-help={t('helpTopics.openItem.body')} data-help-title={t('helpTopics.openItem.title')}>{t('cust.col.outstanding')}</span><b className="t-num">{fmt(combinedOut)}</b></div>
        </div>
        {invoiceConflicts.length ? <div className="alert alert-warning merge-invoice-warning">
          <span className="alert-ico"><Icon name="alertTri" size={18} /></span>
          <div>
            <b>{t('sup.sameInvoiceNumber')}</b>
            <div className="t-sm" style={{ fontWeight: 700, marginTop: 4 }}>{t('sup.checkDuplicates')}</div>
            <div className="merge-invoice-warning-list">
              {invoiceConflicts.slice(0, 4).map((conflict) => <div key={supplierInvoiceNumberKey(conflict.invoiceNumber)} className="merge-invoice-warning-row">
                <b>{conflict.invoiceNumber}</b>
                <span>{supplierInvoiceConflictLabel(conflict.vouchers)} / {supplierInvoiceConflictLabel(conflict.otherVouchers)}</span>
              </div>)}
              {invoiceConflicts.length > 4 ? <div className="t-sm" style={{ fontWeight: 800 }}>{t('sup.mergeMoreInvoiceNumbers', { count: invoiceConflicts.length - 4 })}</div> : null}
            </div>
          </div>
        </div> : null}
      </React.Fragment>}
      {error && <div className="t-sm" style={{ color: 'var(--error)', fontWeight: 800 }}>{error}</div>}
    </div>
  </Modal>;
}
function LeverandorerPage({ client = 'joda', setRoute, setYear }) {
  const store = window.clientStore;
  const readRows = () => store ? store.get(client, 'suppliers', supplierFallback()) : supplierFallback();
  const [rows, setRowsState] = useState(readRows);
  const prevClient = useRef(client);
  useEffect(() => {
    if (prevClient.current !== client) {
      prevClient.current = client;
      setRowsState(readRows());
    }
  }, [client]);
  useEffect(() => {
    const handleChange = () => setRowsState(readRows());
    window.addEventListener('plumme-suppliers-changed', handleChange);
    window.addEventListener('plumme-vouchers-changed', handleChange);
    window.addEventListener('plumme-backend-state', handleChange);
    return () => {
      window.removeEventListener('plumme-suppliers-changed', handleChange);
      window.removeEventListener('plumme-vouchers-changed', handleChange);
      window.removeEventListener('plumme-backend-state', handleChange);
    };
  }, [client]);
  const setRows = (updater) => setRowsState((previous) => {
    const next = typeof updater === 'function' ? updater(previous) : updater;
    if (store) store.set(client, 'suppliers', next);
    return next;
  });
  const [search, setSearch] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [editTarget, setEditTarget] = useState(null);
  const [expandedId, setExpandedId] = useState(null);
  const [mergeTarget, setMergeTarget] = useState(null);
  const [exportMenuOpen, setExportMenuOpen] = useState(false);
  const [filter, setFilter] = useState(() => makeFilter({ checks: { aktiv: true } })); useRegistryPageIntent('supplier', (intent) => { if (intent.action === 'search') { setSearch(intent.query || ''); setExpandedId(null); } if (intent.action === 'open_record') { const row=rows.find(entry=>entry.id===intent.recordId);setSearch(row?.name||'');setFilter(makeFilter({checks:{arkiv:true}}));setExpandedId(intent.recordId||null); } if (intent.action === 'open_merge') { const row=rows.find((entry)=>entry.id===intent.recordId);if(row)setMergeTarget(row); } });
  const filtered = rows
    .filter((supplier) => filter.checks.arkivert ? (filter.checks.aktiv || supplierIsArchived(supplier)) : !supplierIsArchived(supplier))
    .filter((supplier) => !filter.checks.utestaaende || Math.abs(Number(supplier.out) || 0) > 0.005)
    .filter((supplier) => window.PlummeListSearch.matches(search, {
      text: [supplier.nr, supplier.name, supplier.org, supplier.email, supplier.phone],
      amounts: [supplier.out, supplier.buy],
    }));
  const exportSuppliers = async (kind) => {
    if (!filtered.length) { toast(t('sup.noSuppliersToExport'), 'info'); return; }
    try {
      if (kind === 'xlsx') await supplierExportRowsXlsx('plumme-leverandorer', supplierExportColumns(), filtered, t('sup.sheet.suppliers'));
      else window.exportTable('plumme-leverandorer', supplierExportColumns(), filtered, kind);
    } catch (error) {
      toast(error?.message || t('sup.exportListFailed'), 'error');
      return;
    }
    toast(t('sup.exportListDone'), 'success');
  };
  const exportSupplierLedger = async (kind) => {
    const ledgerRows = buildSupplierLedgerRows(filtered);
    if (!ledgerRows.length) { toast(t('sup.noLedgerRowsToExport'), 'info'); return; }
    const filename = 'leverandorer-reskontro-' + new Date().getFullYear();
    try {
      if (kind === 'xlsx') await supplierExportRowsXlsx(filename, supplierLedgerColumns(), ledgerRows, t('sup.sheet.ledger'));
      else window.exportTable(filename, supplierLedgerColumns(), ledgerRows, kind);
    } catch (error) {
      toast(error?.message || t('sup.exportLedgerFailed'), 'error');
      return;
    }
    toast(t('sup.exportLedgerDone'), 'success');
  };
  const supplierHeaderTools = <div className="customer-header-tools">
    <div className="popwrap">
      <button type="button" className="customer-transfer-trigger" aria-label={t('list.export')} title={t('list.export')} onClick={() => setExportMenuOpen((open) => !open)}>
        <Icon name="download" size={18} /><Icon name="chevDown" size={18} />
      </button>
      {exportMenuOpen && <React.Fragment><div className="pop-scrim" onClick={() => setExportMenuOpen(false)} />
        <div className="pop customer-transfer-menu customer-transfer-menu-export">
          <div className="customer-transfer-section">{t('nav.suppliers')}</div>
          <button onClick={() => { setExportMenuOpen(false); exportSuppliers('csv'); }}><Icon name="fileText" size={20} /><span>{t('sup.exportCsv')}</span></button>
          <button onClick={() => { setExportMenuOpen(false); exportSuppliers('xlsx'); }}><Icon name="files" size={20} /><span>{t('sup.exportExcel')}</span></button>
          <div className="customer-transfer-sep" />
          <div className="customer-transfer-section">{t('cust.ledgerShort')}</div>
          <button onClick={() => { setExportMenuOpen(false); exportSupplierLedger('csv'); }}><Icon name="fileText" size={20} /><span>{t('sup.ledgerCsv')}</span></button>
          <button onClick={() => { setExportMenuOpen(false); exportSupplierLedger('xlsx'); }}><Icon name="files" size={20} /><span>{t('sup.ledgerExcel')}</span></button>
        </div></React.Fragment>}
    </div>
  </div>;
  const supplierSearchHelp = t('sup.searchHelp');
  const supplierFilterEl = <FilterPanel value={filter} onChange={setFilter} onReset={() => setFilter(makeFilter({ checks: { aktiv: true } }))} groups={[{ label: t('cust.status'), options: [{ key: 'aktiv', label: t('common.active') }, { key: 'arkivert', label: t('cust.archived') }] }, { label: t('cust.filterOther'), options: [{ key: 'utestaaende', label: t('cust.filterWithOutstanding') }] }]} />;
  const saveSupplier = async (supplier) => {
    const nextSupplier = supplier.id ? supplier : { ...supplier, id: 's' + Date.now(), out: 0, buy: 0, status: supplier.status || 'aktiv' };
    if (window.PlummeBackend?.saveSupplierRecord) {
      const saved = await window.PlummeBackend.saveSupplierRecord(nextSupplier);
      if (saved) setRowsState((current) => [saved, ...current.filter((entry) => entry.id !== saved.id)]);
      toast(supplier.id ? t('sup.updated') : t('sup.saved'), 'success');
      setEditTarget(null);
      return;
    }
    setRows((current) => supplier.id ? current.map((entry) => entry.id === supplier.id ? nextSupplier : entry) : [nextSupplier, ...current]);
    toast(supplier.id ? t('sup.updated') : t('sup.saved'), 'success');
    setEditTarget(null);
  };
  const archiveSupplier = async () => {
    if (!deleteTarget) return;
    if (window.PlummeBackend?.archiveSupplierRecord) {
      try {
        const archived = await window.PlummeBackend.archiveSupplierRecord(deleteTarget.id);
        if (archived) setRowsState((current) => current.map((entry) => entry.id === archived.id ? archived : entry));
        setExpandedId(null);
        setDeleteTarget(null);
        toast(t('sup.archived'), 'success');
      } catch (error) {
        toast(error?.message || t('sup.archiveFailed'), 'error');
      }
      return;
    }
    setRows((current) => current.map((entry) => entry.id === deleteTarget.id ? { ...entry, status: 'passiv' } : entry));
    setExpandedId(null);
    setDeleteTarget(null);
    toast(t('sup.archived'), 'success');
  };
  const reopenSupplier = async (supplier) => {
    try {
      const reopened = window.PlummeBackend?.saveSupplierRecord
        ? await window.PlummeBackend.saveSupplierRecord({ ...supplier, status: 'aktiv' })
        : { ...supplier, status: 'aktiv' };
      if (window.PlummeBackend?.saveSupplierRecord) setRowsState((current) => current.map((entry) => entry.id === reopened.id ? reopened : entry));
      else setRows((current) => current.map((entry) => entry.id === supplier.id ? reopened : entry));
      toast(t('sup.reopened'), 'success');
    } catch (error) { toast(error?.message || t('sup.reopenFailed'), 'error'); }
  };
  return <div>
    <ListShell title={t('nav.suppliers')} subtitle={t('sup.whoYouBuyFrom')} searchPh={t('sup.searchListPh')}
      help titleHelp={t('sup.titleHelp')}
      searchHelp={supplierSearchHelp}
      downloadHelp={t('sup.downloadHelp')}
      addHelp={t('sup.addHelp')}
      search={search} setSearch={setSearch} onAdd={() => setEditTarget({})} addLabel={t('vat.supplierNew')} splitList noHeaderSearch headerTools={supplierHeaderTools}>
      {/* Søk + filter i egen verktøyrad over lista, ikke i sidehodet */}
      <div className="fak-list-tools">
        <SearchField value={search} onChange={setSearch} placeholder={t('sup.searchListPh')} help={supplierSearchHelp} />
        {supplierFilterEl}
      </div>
      <DataList rows={filtered} rowKey={(supplier) => supplier.id} tableClass="sup-tbl"
        onRowClick={(supplier) => setExpandedId(expandedId === supplier.id ? null : supplier.id)}
        expandedKey={expandedId} renderExpanded={(supplier) => <SupplierDetail supplier={supplier} setRoute={setRoute} setYear={setYear} onEdit={() => setEditTarget(supplier)} onDelete={() => setDeleteTarget(supplier)} onReopen={() => reopenSupplier(supplier)} onMerge={() => setMergeTarget(supplier)} />}
        columns={[
          { header: t('sup.col.name'), render: (supplier) => <React.Fragment>
            <div className="t-h3" style={{ fontSize: 14.5 }}>{supplier.name}</div>
            {supplierHasValue(supplier.nr) && <div className="sup-number-inline t-xs muted"><b>{t('sup.numberShort')}</b> {supplier.nr}</div>}
            {supplierHasValue(supplier.org) && <div className="sup-org-inline t-xs muted"><b>{t('cust.col.org')}</b> {supplier.org}</div>}
            {supplierHasValue(supplier.email) && <div className="sup-email-inline t-xs muted"><Icon name="mail" size={12} />{supplier.email}</div>}
            {supplierHasValue(supplier.phone) && <div className="sup-phone-inline t-xs muted"><Icon name="phone" size={12} />{supplier.phone}</div>}
          </React.Fragment> },
          { header: t('sup.numberShort'), thClass: 'sup-number-col', cellClass: 't-sm muted sup-number-col', render: (supplier) => supplierPlaceholder(supplier.nr) },
          { header: t('cust.col.org'), thClass: 'sup-org-col', cellClass: 't-sm muted sup-org-col', render: (supplier) => supplierPlaceholder(supplier.org) },
          { header: t('cust.col.email'), thClass: 'sup-email-col', cellClass: 't-sm muted sup-email-col', render: (supplier) => <CopyText text={supplier.email} /> },
          { header: t('cust.col.phone'), thClass: 'sup-phone-col', cellClass: 't-sm muted sup-phone-col', render: (supplier) => supplierPlaceholder(supplier.phone) },
          { header: <span data-help-title={t('cust.col.outstanding')} data-help={t('sup.outstandingHelp')}>{t('cust.col.outstanding')}</span>, headerRight: true, thClass: 'sup-out-col', cellClass: 'num sup-out-col', tdStyle: (supplier) => ({ color: supplierNetBalanceMeta(supplier.out).tone }), render: (supplier) => fmt(supplier.out) },
          { header: <span data-help-title={t('sup.totalPurchases')} data-help={t('sup.totalPurchasesHelp')}>{t('sup.totalPurchases')}</span>, headerRight: true, cellClass: 'num', render: (supplier) => { const meta = supplierNetBalanceMeta(supplier.out); return <React.Fragment>{fmt(supplier.buy)}<div className="sup-out-sub" style={{ color: meta.tone }}>{meta.text}</div></React.Fragment>; } },
        ]} />
    </ListShell>
    <ConfirmDelete open={!!deleteTarget} name={deleteTarget?.name} onClose={() => setDeleteTarget(null)} onConfirm={archiveSupplier} archive bodyKey="sup.archiveBody" />
    <SupplierMergeModal supplier={mergeTarget} suppliers={rows} onClose={() => setMergeTarget(null)} onMerged={(nextRows) => { if (nextRows?.length) setRowsState(nextRows); }} />
    {editTarget && <SupplierEditModal supplier={editTarget} onClose={() => setEditTarget(null)} onSave={saveSupplier} />}
  </div>;
}
Object.assign(window, { LeverandorerPage, SupplierRegistryLookup, supplierDraftFromRegistryMatch });
